import countries from './countriesSAP';

/**
 * @name getProvinceMapForCountry
 * @desc Get a map of a country's province/state codes to province/state name. Used by the Address Book and in Checkout
 * @param {String} countryCode the country code of the selected account
 */
const getProvinceMapForCountry = countryCode => {
  return (
    countries
      .find(c => c.code2 === countryCode)
      ?.states?.reduce((provinceMap, province) => ({ ...provinceMap, [province.code]: province.name }), {}) || {}
  );
};

export default getProvinceMapForCountry;
